module.exports = __webpack_public_path__ + "img/icon-stockpicker-training@3x.d1b33d80.png";